const SEQUENCES_PATH = 'img/sequences/'

export const SEQUENCES = {
  what: {
    id: 'what',
    path: `${SEQUENCES_PATH}blueprint/what/`,
    totalSlidesCount: 81,
    duration: 60,
    trigger: 0.7,
  },
  steps: [
    {
      id: 'step01',
      path: `${SEQUENCES_PATH}blueprint/step01/`,
      totalSlidesCount: 11,
      duration: 11,
      trigger: 0.4,
    },
    {
      id: 'step02',
      path: `${SEQUENCES_PATH}blueprint/step02/`,
      totalSlidesCount: 35,
      duration: 35,
      trigger: 0.53,
    },
    {
      id: 'step03',
      path: `${SEQUENCES_PATH}blueprint/step03/`,
      totalSlidesCount: 46,
      duration: 46,
      trigger: 0.7,
    },
    {
      id: 'step04',
      path: `${SEQUENCES_PATH}blueprint/step04/`,
      totalSlidesCount: 34,
      duration: 34,
      trigger: 0.53,
    },
  ],
  solution: {
    id: 'solution',
    path: `${SEQUENCES_PATH}blueprint/solution/`,
    totalSlidesCount: 24,
    duration: 24,
    trigger: 0.48,
  },
}
